import React, { useEffect, useMemo, useState } from 'react';
import { Formik } from 'formik';
import { isEqual } from 'lodash';
import { useDonaturUIContext } from '../DonaturUIContext';
import { donaturTypeList, initialFilter } from '../DonaturUIHelpers'
// import moment from "moment";
import { getBranchAll } from '../../MasterData/_redux/branchs/branchCrud'
import { DateRangePicker } from "react-dates";
import 'react-dates/lib/css/_datepicker.css';
import 'react-dates/initialize';
import { letterChoice, } from '../DonaturUIHelpers'
import moment from 'moment'

const prepareFilter = (queryParams, values) => {
    const { name, type, kd_cc, email, hp, city, provinsi, start_date, end_date, branch, is_letters, donor_id } = values;
    const newQueryParams = { ...queryParams };
    const filter = {};

    //add to Object filter
    filter.name = name;
    filter.type = type
    filter.kd_cc = kd_cc
    filter.email = email
    filter.hp = hp
    filter.city = city
    filter.provinsi = provinsi
    filter.start_date = start_date ? start_date : ''
    filter.end_date = end_date ? end_date : ''
    filter.branch = branch
    filter.is_letters = is_letters
    filter.donor_id = donor_id ?? '';
    filter.filterCabang = true

    newQueryParams.filter = filter;
    return newQueryParams;
};

const DonaturFilter = ({ listLoading }) => {
    // Branchs UI Context
    const donaturUIContext = useDonaturUIContext();
    const donaturUIProps = useMemo(() => {
        return {
            setQueryParams: donaturUIContext.setQueryParams,
            queryParams: donaturUIContext.queryParams,
        };
    }, [donaturUIContext]);

    const applyFilter = (values) => {
        const newQueryParams = prepareFilter(donaturUIProps.queryParams, values);
        if (!isEqual(newQueryParams, donaturUIProps.queryParams)) {
            newQueryParams.pageNumber = 1;
            donaturUIProps.setQueryParams(newQueryParams);
        }
    };

    const [branchList, setBranchList] = useState([])
    //UNTUK DATERANGE
    const [onFocused, setOnFocused] = useState(null)
    const [tanggal, setTanggal] = useState(
        {
            start_date: moment().subtract(1, 'months'),
            end_date: moment(),
        }
    )
    const fetchBranch = async (value) => {
        const result = await getBranchAll()
        setBranchList(result.data.data)
    }

    useEffect(() => {
        fetchBranch()
    }, [])

    return (
        <Formik initialValues={initialFilter.filter} onSubmit={(values) => {
            applyFilter(values);
        }}
        >{({ values, handleSubmit, handleBlur, setFieldValue, handleChange }) => (
            <>
                <form onSubmit={handleSubmit} className="form form-label-right">
                    <div className="form-group row">
                        <div className="col-lg-4">
                            <DateRangePicker
                                small={true}
                                startDate={tanggal.start_date}
                                endDate={tanggal.end_date}
                                onDatesChange={({ startDate, endDate }) => {
                                    setTanggal({
                                        start_date: startDate,
                                        end_date: endDate
                                    })
                                    setFieldValue('start_date', startDate)
                                    setFieldValue('end_date', endDate)

                                }}
                                focusedInput={onFocused}
                                onFocusChange={focusedInput => setOnFocused(focusedInput)}
                                numberOfMonths={1}
                                isOutsideRange={() => false}
                                showClearDates={true}
                                startDateId="start_date"
                                endDateId="end_date"
                                hideKeyboardShortcutsPanel={true}
                            />
                            <small className="form-text text-muted ">
                                <b> hanya untuk export maks range 1 bulan</b>
                            </small>
                        </div>
                        <div className="col-lg-4">
                            <input
                                type="text"
                                className="form-control"
                                name="donor_id"
                                placeholder="Contoh: 322111"
                                onBlur={handleBlur}
                                onChange={(e) => {
                                    setFieldValue('donor_id', e.target.value);
                                }}
                            />
                            <small className="form-text text-muted">
                                <b>Cari</b> ID Donatur
                            </small>
                        </div>
                        <div className="col-lg-4">
                            <input
                                type="text"
                                className="form-control"
                                name="kd_cc"
                                placeholder="Contoh: 08832"
                                onBlur={handleBlur}
                                value={values.kd_cc}
                                onChange={(e) => {
                                    setFieldValue('kd_cc', e.target.value);
                                }}
                            />
                            <small className="form-text text-muted">
                                Cari Berdasarkan <b>Kode CC</b>
                            </small>
                        </div>
                    </div>
                    <div className="form-group row">
                        <div className="col-lg-4">
                            <input
                                type="text"
                                className="form-control"
                                name="name"
                                placeholder="Contoh: Hamba Allah"
                                onBlur={handleBlur}
                                value={values.name}
                                onChange={(e) => {
                                    setFieldValue('name', e.target.value);
                                }}
                            />
                            <small className="form-text text-muted">
                                Cari Berdasarkan <b>Nama Donatur</b>
                            </small>
                        </div>
                        <div className="col-lg-4">
                            <input
                                type="text"
                                className="form-control"
                                name="email"
                                placeholder="Contoh: fulan@fulan.com"
                                onBlur={handleBlur}
                                value={values.email}
                                onChange={(e) => {
                                    setFieldValue('email', e.target.value);

                                }}
                            />
                            <small className="form-text text-muted">
                                Cari berdasarkan <b>Email</b>
                            </small>
                        </div>
                        <div className="col-lg-4">
                            <input
                                type="text"
                                className="form-control"
                                name="hp"
                                placeholder="Contoh: 081281..."
                                onBlur={handleBlur}
                                value={values.hp}
                                onChange={(e) => {
                                    setFieldValue('hp', e.target.value);

                                }}
                            />
                            <small className="form-text text-muted">
                                Cari berdasarkan <b>Nomor Hp</b>
                            </small>
                        </div>
                    </div>
                    <div className="form-group row">
                        <div className="col-lg-4">
                            <input
                                type="text"
                                className="form-control"
                                name="city"
                                placeholder="Contoh: bandung"
                                onBlur={handleBlur}
                                value={values.city}
                                onChange={(e) => {
                                    setFieldValue('city', e.target.value);

                                }}
                            />
                            <small className="form-text text-muted">
                                Cari Berdasarkan <b>Nama Kota</b>
                            </small>
                        </div>
                        <div className="col-lg-4">
                            <input
                                type="text"
                                className="form-control"
                                name="provinsi"
                                placeholder="Contoh: Jawa Barat"
                                onBlur={handleBlur}
                                value={values.provinsi}
                                onChange={(e) => {
                                    setFieldValue('provinsi', e.target.value);

                                }}
                            />
                            <small className="form-text text-muted">
                                Cari Berdasarkan <b>Nama Provinsi</b>
                            </small>
                        </div>
                        {/* <div className="col-lg-4">
                            <select
                                className="form-control"
                                placeholder="Nama Cabang"
                                name="branch"
                                onBlur={handleBlur}
                                onChange={(e) => {
                                    setFieldValue('branch', e.target.value);

                                }}
                                value={values.branch}
                            >
                                <option value=''>ALL</option>
                                ,
                                {branchList.map(list =>
                                    <option key={list.uuid} value={list.uuid}>{list.name}</option>,
                                )}
                            </select>
                            <small className="form-text text-muted">
                                Cari berdasarkan <b>Cabang</b>
                            </small>
                        </div> */}
                    </div>
                    <div className="form-group row">
                        <div className="col-lg-4">
                            <select
                                className="form-control"
                                placeholder="Filter Type"
                                name="type"
                                onBlur={handleBlur}
                                onChange={(e) => {
                                    setFieldValue('type', e.target.value);

                                }}
                                value={values.type}
                            >
                                <option value=''>ALL</option>
                                ,
                                {donaturTypeList.map(list =>
                                    <option key={list.value} value={list.value}>{list.name}</option>,
                                )}
                            </select>
                            <small className="form-text text-muted">
                                Cari berdasarkan <b>Tipe Donatur</b>
                            </small>
                        </div>
                        <div className="col-lg-4">
                            <select
                                className="form-control"
                                placeholder="Filter Type"
                                name="is_letters"
                                onBlur={handleBlur}
                                onChange={(e) => {
                                    setFieldValue('is_letters', e.target.value);

                                }}
                                value={values.is_letters}
                            >
                                <option value="">ALL</option>
                                {letterChoice.map(row =>
                                    <option key={row.name} value={row.value}>{row.name}</option>
                                )}
                            </select>
                            <small className="form-text text-muted">
                                Cari Berdasarkan <b>Penerimaan Hard Copy</b>
                            </small>
                        </div>
                    </div>
                </form>
                <button
                    onClick={() => handleSubmit()}
                    className="btn btn-primary btn-elevate float-right mb-20"
                >
                    Cari
                </button>
                <hr className="mt-25" />
            </>
        )}
        </Formik>

    );
}
    ;

export default DonaturFilter;

